"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGlobal = exports.renderContent = exports.GlobalizationProvider = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _fetchUnlessCached = require("fetch-unless-cached");
var _utils = require("./utils");
var _celebrityCountryInfo = require("./celebrityCountryInfo");
const isWindowReady = typeof window !== 'undefined';
const GlobalContext = /*#__PURE__*/_react.default.createContext();
const renderOptionsFindReplace = (message, object) => {
  let replacedMsg;
  object.forEach(findReplace => {
    replacedMsg = message.replace(findReplace.find, findReplace.replace);
  });
  return replacedMsg;
};
const renderContent = dictionary => (key, defaultText, options) => {
  let renderMessage = !(key in dictionary) ? defaultText : dictionary[key];
  if (options && options.findReplace) {
    renderMessage = renderOptionsFindReplace(renderMessage, options.findReplace);
  }
  return renderMessage;
};
exports.renderContent = renderContent;
const currentCntry = isWindowReady && (0, _utils.currentCountry)();
const getCountryCelebrityAir = country => {
  return _celebrityCountryInfo.celebrityCountryMap[country.toUpperCase()] || _celebrityCountryInfo.celebrityCountryMap['USA'];
};
const GlobalizationProvider = props => {
  const {
    url,
    cacheTime = 300,
    dicName,
    dict = {},
    defaultGlobalPayload = {
      market: currentCntry,
      code: currentCntry,
      language: isWindowReady && (0, _utils.currentLang)()
    },
    _isError,
    _isLoading
  } = props;
  const [globalPayload, setGlobalPayload] = _react.default.useState(defaultGlobalPayload);
  const [dictionary, setDictionary] = _react.default.useState(dict);
  const [isLoading, setIsLoading] = _react.default.useState(_isLoading !== false);
  const [isError, setIsError] = _react.default.useState(_isError || false);
  const globalizationData = countryCode => (0, _fetchUnlessCached.createfetchUnlessCached)(cacheTime)("".concat(url, "globalization?country=").concat(countryCode));
  _react.default.useEffect(() => {
    (async () => {
      if (url) {
        setIsError(false);
        setIsLoading(true);
        try {
          const globalization = url.includes('celebritycruises') || url.includes('0.0.0.0') ? getCountryCelebrityAir(globalPayload.code) : await globalizationData(globalPayload.code);
          let {
            selectedCountry
          } = globalization;

          // Use globalization data from query param or cookie if market code is the same between referer
          // and current page. This allows staying in the selected country for shared markets such as LAC.
          const pathCountryMarket = (0, _utils.currentCountry)(false).toLowerCase();
          const countryMarketMatch = globalPayload.code.toLowerCase() === pathCountryMarket || selectedCountry.market.toLowerCase() === pathCountryMarket;
          if (!countryMarketMatch) {
            const pathGlobalization = url.includes('celebritycruises') || url.includes('0.0.0.0') ? getCountryCelebrityAir(pathCountryMarket) : await globalizationData(pathCountryMarket);
            selectedCountry = pathGlobalization.selectedCountry;
          }
          const selectedLanguage = selectedCountry.languages.find(lang => lang.language === globalPayload.language);
          if (selectedLanguage) {
            selectedCountry = {
              ...selectedCountry,
              language: selectedLanguage.language,
              locale: selectedLanguage.locale
            };
          }
          const {
            locale,
            language
          } = selectedCountry;
          let aemDictionary = language;
          try {
            const i18nConversion = await (0, _fetchUnlessCached.createfetchUnlessCached)(cacheTime)("".concat(url, "i18nConversion"));
            const i18nAppendConversion = {
              ...i18nConversion,
              ..._utils.i18nConversionAppend
            };
            if (i18nAppendConversion && locale) {
              const localeConversion = i18nAppendConversion[locale];
              if (localeConversion) {
                selectedCountry = {
                  ...selectedCountry,
                  dayJSLangCode: localeConversion.dayjsLocale || language
                };
                aemDictionary = localeConversion.aemDictionary;
              }
            }
          } catch (error) {
            // eslint-disable-next-line no-console
            console.warn(error);
          }
          try {
            const i18n = await (0, _fetchUnlessCached.createfetchUnlessCached)(cacheTime)("".concat(url, "dictionary?dictName=").concat(dicName, "&langCd=").concat(aemDictionary));
            setDictionary(i18n);
          } catch (error) {
            // eslint-disable-next-line no-console
            console.warn(error);
          }
          setGlobalPayload(selectedCountry);
          (0, _utils.setMarketCookies)({
            country: selectedCountry.code,
            language
          });
        } catch (error) {
          setIsError(error);
        }
        setIsLoading(false);
      }
    })();
  }, [cacheTime, dicName, globalPayload.code, url]);
  const value = _react.default.useMemo(() => [globalPayload, isError, isLoading, dictionary], [globalPayload, isError, isLoading, dictionary]);
  return /*#__PURE__*/_react.default.createElement(GlobalContext.Provider, (0, _extends2.default)({
    value: value
  }, props));
};
exports.GlobalizationProvider = GlobalizationProvider;
const useGlobal = () => {
  const context = _react.default.useContext(GlobalContext);
  if (!context) {
    throw new Error("useGlobal must be used within a GlobalizationProvider");
  }
  const [globalPayload, isError, isLoading, dictionary] = context;
  const dayjs = isWindowReady && (0, _utils.getLocalizedDayjs)(globalPayload);
  return {
    data: {
      market: globalPayload.market,
      currency: globalPayload.selectedCurrency,
      country: globalPayload.code,
      lang: globalPayload.language,
      isoCode: globalPayload.isoAlpha2Code,
      localizedDayjs: dayjs,
      office: globalPayload.officeCode
    },
    dictionary,
    renderContent: renderContent(dictionary),
    error: isError,
    loading: isLoading
  };
};
exports.useGlobal = useGlobal;